import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {
	Box,
	Button,
	Dialog,
	Link,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

const LOCAL_STORAGE_KEY = "timocom_info_31032026a";

import csLogo from "../../assets/favicon.png";
import background from "../../assets/promo-bg.jpg";

export const PromotionDialog = () => {
	const { t, i18n } = useTranslation();
	const currentLang = i18n?.language || "pl";
	const [openPromotionPopup, setOpenPromotionPopup] = useState(false);

	// lock close button for 20 seconds
	const [lockCloseButton, setLockCloseButton] = useState(true);
	const [lockCounter, setLockCounter] = useState(20);

	// unlock button after 20 seconds
	useEffect(() => {
		if (lockCounter === 0) {
			setLockCloseButton(false);
			return;
		}

		const interval = setInterval(() => {
			setLockCounter((prev) => prev - 1);
		}, 1000);

		return () => clearInterval(interval);
	}, [lockCounter]);

	// show promotion popup only if today is the same or after the promotion date
	useEffect(() => {
		if (localStorage.getItem(LOCAL_STORAGE_KEY) !== "true") {
			setOpenPromotionPopup(true);
			localStorage.setItem(LOCAL_STORAGE_KEY, "true");
		}
	}, []);

	return (
		<Dialog
			fullWidth
			maxWidth="md"
			onClose={(_e, reason) => {
				if (reason === "backdropClick") return;
				setOpenPromotionPopup(false);
			}}
			open={openPromotionPopup}
			disableEscapeKeyDown={true}
		>
			<Box
				sx={{
					padding: "30px 30px",
					background: `url(${background}) no-repeat center/cover`,
					position: "relative",
				}}
			>
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						position: "absolute",
						top: 0,
						right: "20px",
						background: "#4d4d4d",
						borderBottomLeftRadius: "8px",
						borderBottomRightRadius: "8px",
						padding: "3px 2px",
						overflow: "hidden",
					}}
				>
					<img src={csLogo} alt="CARGOseller Logo" width={40} />
				</Box>
				{currentLang === "pl" ? <PLContent /> : <ENContent />}
				<Box
					sx={{
						width: "100%",
						display: "flex",
						justifyContent: "center",
						gap: "20px",
						marginTop: "30px",
					}}
				>
					<Button
						variant="contained"
						color="error"
						disabled={lockCloseButton}
						onClick={() => setOpenPromotionPopup(false)}
						sx={{
							textTransform: "uppercase",
							background: "#585858",
							"&:hover": {
								background: "#474646",
							},
						}}
					>
						{t("close")} {lockCounter > 0 && `(${lockCounter})`}
					</Button>
				</Box>
			</Box>
		</Dialog>
	);
};

const PLContent = () => {
	return (
		<>
			<Box sx={{ position: "relative" }}>
				<Typography variant="h6" sx={{ fontWeight: "600" }}>
					Witaj,
				</Typography>
				<Typography variant="body1" sx={{ mt: "8px" }}>
					Dzisiaj zachodzi ważna zmiana w systemie w zakresie obsługi giełdy
					Timocom. Poświęć chwilę, aby komfortowo przejść przez tę zmianę.
				</Typography>
				<Typography variant="body1" sx={{ mt: "8px" }}>
					Rzeczą naturalną w biznesie jest optymalizacja, podnoszenie
					efektywności pracownika i sprzedaży, nikt nie chce się uwsteczniać,
					przepisywać ręcznie, powielać zadań kilka razy. Aby umożliwić Państwu
					kontynuowanie takiej właśnie pracy tj. zarządzanie sprzedażą z jednego
					miejsca, importowania ofert z Transporeon oraz używanie AI do
					publikowania za jednym razem na kilka kanałów sprzedaży
					przygotowaliśmy nową aplikację, która umożliwia zminimalizowanie
					skutków decyzji Timocom o wyłączeniu integracji dla systemów
					umożliwiających publikacje na kilka kanałów sprzedaży.
				</Typography>
				<Typography
					variant="body1"
					sx={{ marginTop: "10px", fontWeight: "600" }}
				>
					Co należy wiedzieć:
				</Typography>
				<Box>
					<List dense={false} disablePadding={true}>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<ChevronRightIcon color="primary" />
							</ListItemIcon>
							<ListItemText
								primary={`Aby kontynuować publikowanie, usuwanie, odświeżanie ładunków należy pobrać aplikację CS Desktop dostępną w sekcji API/TIMOCOM.`}
							/>
						</ListItem>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<ChevronRightIcon color="primary" />
							</ListItemIcon>
							<ListItemText
								primary={`Po uruchomieniu aplikacji znajdziesz ją po prawej stronie na dole na pasku Windows.`}
							/>
						</ListItem>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<ChevronRightIcon color="primary" />
							</ListItemIcon>
							<ListItemText
								primary={`Uzupełnij Login oraz Hasło dla Timocom, dane nie są wysyłane do naszego serwera, są przechowywane lokalnie na Twoim komputerze.`}
							/>
						</ListItem>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<ChevronRightIcon color="primary" />
							</ListItemIcon>
							<ListItemText
								primary={`W lewym górnym rogu ekranu znajdziesz status połączenia aplikacji Desktop z systemem w przeglądarce, powinien wskazywać "Połączono".`}
							/>
						</ListItem>
						<ListItem
							disablePadding={true}
							disableGutters={true}
							alignItems="flex-start"
						>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<ChevronRightIcon color="primary" />
							</ListItemIcon>
							<ListItemText
								primary={`Pracujesz tak jak do tej pory, aplikacja automatycznie wykona w tle zadania naśladując pracę człowieka (np. wypełniając po kolei pola formularza czy usuwając ofertę).`}
							/>
						</ListItem>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<ChevronRightIcon color="primary" />
							</ListItemIcon>
							<ListItemText
								primary={`Nie zamykaj okna/karty systemu od razu po dodaniu/usunięciu/odświeżeniu oferty ponieważ zadanie zostanie przerwane.`}
							/>
						</ListItem>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<ChevronRightIcon color="primary" />
							</ListItemIcon>
							<ListItemText
								primary={`Pierwsza publikacja ładunku będzie specyficzna ponieważ jednorazowo trzeba będzie podać kod otrzymany mailem od Timocom w celu potwierdzenia, że to Ty wykonujesz nowe zalogowanie w nowej przeglądarce oraz zapisać ją jako zaufaną, to ona będzie automatyzowała dla Ciebie zadania, całość obsługi wykonuje się lokalnie z Twojego komputera zupełnie jakbyś Ty to robił(a).`}
							/>
						</ListItem>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<ChevronRightIcon color="primary" />
							</ListItemIcon>
							<ListItemText
								primary={`Zalecamy obejrzenie filmiku instruktażowego dostępnego w sekcji API/TIMOCOM, to tylko 6 min.`}
							/>
						</ListItem>
					</List>
				</Box>
			</Box>
			<Box sx={{ marginTop: "20px" }}>
				<Typography variant="body1">
					Rozwiązanie, które Państwu dostarczamy zostało przygotowane tak
					bezpiecznie jak to możliwe - nie wysyła na nasz serwer loginów i
					haseł, pracuje za człowieka naśladując jego pracę.
				</Typography>
				<Typography variant="body1" sx={{ mt: "8px" }}>
					Jeżeli napotkasz problem skontaktuj się z nami na adres{" "}
					<Link href="mailto:support@cargoseller.pl">
						support@cargoseller.pl
					</Link>{" "}
					a my postaramy się pomóc.
				</Typography>
			</Box>
			<Box
				sx={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}
			>
				<Typography variant="body1">
					Pozdrawiamy
					<br />
					Zespół{" "}
					<b>
						CARGO<span style={{ color: "#63C29A" }}>seller</span>
					</b>
				</Typography>
			</Box>
		</>
	);
};

const ENContent = () => {
	return (
		<>
			<Box sx={{ position: "relative" }}>
				<Typography variant="h6" sx={{ fontWeight: "600" }}>
					Hello,
				</Typography>
				<Typography variant="body1" sx={{ mt: "8px" }}>
					Today, an important change is being introduced in the system regarding
					the handling of the Timocom exchange. Please take a moment to
					comfortably transition through this change.
				</Typography>
				<Typography variant="body1" sx={{ mt: "8px" }}>
					It is natural in business to optimize, increase employee and sales
					efficiency, no one wants to move backward, manually rewrite data or
					duplicate tasks multiple times. To allow you to continue working in
					this way - managing sales from a single place, importing offers from
					Transporeon and using AI to publish simultaneously across multiple
					sales channels we have prepared a new supporting application. This
					application minimizes the impact of Timocom’s decision to disable
					integration for systems that enable publishing across multiple sales
					channels.
				</Typography>
				<Typography
					variant="body1"
					sx={{ marginTop: "10px", fontWeight: "600" }}
				>
					What you need to know:
				</Typography>
				<Box>
					<List dense={false} disablePadding={true}>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<ChevronRightIcon color="primary" />
							</ListItemIcon>
							<ListItemText
								primary={`To continue publishing, deleting, and refreshing loads, you need to download the CS Desktop app from the API/TIMOCOM section.`}
							/>
						</ListItem>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<ChevronRightIcon color="primary" />
							</ListItemIcon>
							<ListItemText
								primary={`After launching the application, you will find it in the bottom-right corner of your Windows taskbar.`}
							/>
						</ListItem>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<ChevronRightIcon color="primary" />
							</ListItemIcon>
							<ListItemText
								primary={`Enter your Timocom Login and Password. This data is not sent to our server, it is stored locally on your computer.`}
							/>
						</ListItem>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<ChevronRightIcon color="primary" />
							</ListItemIcon>
							<ListItemText
								primary={`In the top-left corner of the screen, you will find the connection status between the Desktop app and the system in web browser, it should display "Connected".`}
							/>
						</ListItem>
						<ListItem
							disablePadding={true}
							disableGutters={true}
							alignItems="flex-start"
						>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<ChevronRightIcon color="primary" />
							</ListItemIcon>
							<ListItemText
								primary={`You can work as before, the application will automatically perform tasks in the background by simulating human actions (e.g., filling in form fields step by step or removing an offer).`}
							/>
						</ListItem>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<ChevronRightIcon color="primary" />
							</ListItemIcon>
							<ListItemText
								primary={`Do not close the system window/tab immediately after adding/removing/refreshing an offer, as the task will be interrupted.`}
							/>
						</ListItem>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<ChevronRightIcon color="primary" />
							</ListItemIcon>
							<ListItemText
								primary={`The first load publication will be slightly different, as you will need to enter a one-time code sent by Timocom via email to confirm that it is you logging in through a new browser and mark it as trusted. This browser will then automate tasks for you. All operations are performed locally on your computer, just as if you were doing them yourself.`}
							/>
						</ListItem>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<ChevronRightIcon color="primary" />
							</ListItemIcon>
							<ListItemText
								primary={`We recommend watching the instructional video available in the API/TIMOCOM section, it’s only 6 minutes long.`}
							/>
						</ListItem>
					</List>
				</Box>
			</Box>
			<Box sx={{ marginTop: "20px" }}>
				<Typography variant="body1">
					The solution we provide has been designed to be as secure as possible
					- it does not send us your login credentials and performs actions on
					behalf of the user by simulating human work.
				</Typography>
				<Typography variant="body1" sx={{ mt: "8px" }}>
					If you encounter any issues, please contact us at{" "}
					<Link href="mailto:support@cargoseller.pl">
						support@cargoseller.pl
					</Link>{" "}
					and we will do our best to help.
				</Typography>
			</Box>
			<Box
				sx={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}
			>
				<Typography variant="body1">
					Best regards
					<br />
					<b>
						CARGO<span style={{ color: "#63C29A" }}>seller</span>
					</b>{" "}
					Team
				</Typography>
			</Box>
		</>
	);
};
